import { KpiType, KpiWithMetrics } from '@/shared/types/api';

export function getKpiTypeText(
  kpiType: KpiType | null,
  t: (key: string) => string,
): string {
  if (!kpiType) {
    return '';
  }

  switch (kpiType) {
    case KpiType.NOMINAL:
      return t('nominal');
    case KpiType.RELATIVE:
      return t('relative');
  }

  return '';
}

export function getKpiUniqueId(kpi: KpiWithMetrics | undefined) {
  if (!kpi) {
    return '';
  }

  return `${kpi.id}-${kpi.project_id}-${isDerivativeKpi(kpi)}`;
}

export function isDerivativeKpi(kpi: KpiWithMetrics) {
  return 'operation' in kpi && kpi.operation != null;
}
